/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const EmployeeContractImportErrors = {
    MISSING_EMPLOYEE: 'MISSING_EMPLOYEE',
    MISSING_COMPANY: 'MISSING_COMPANY',
    MISSING_OCCUPATION: 'MISSING_OCCUPATION',
    MISSING_WORKPLACE: 'MISSING_WORKPLACE',
    MISSING_VALIDITY_START: 'MISSING_VALIDITY_START',
    INVALID_VALIDITY_START_BEFORE_END: 'INVALID_VALIDITY_START_BEFORE_END',
    DUPLICATE_CONTRACT: 'DUPLICATE_CONTRACT'
} as const;
export type EmployeeContractImportErrors = typeof EmployeeContractImportErrors[keyof typeof EmployeeContractImportErrors];

